import { userAvatar } from 'Services/avatarGenerator'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

/**
 * @param {ApiUserAccount} data
 * @returns {UserAccount}
 */
export const parseUserAccount = (data) => ({
  id: data.id,
  name: data.name,
  occupation: data.occupation,
  otherOccupation: data.otherOccupation,
  email: data.email,
  birthday: data.birthday ? format(parseISO(data.birthday), 'yyyy-MM-dd') : '',
  avatar: userAvatar(data.photoUrl, data.name),
  phoneList:  data.phones.map((value)=> {
    return {
      id:     value.idPhone,
      ddd:    value.ddd || '',
      number: value.number || '',
      isMain: value.isMain || false,
      linkedWithTwoFactor: value.linkedWithTwoFactor || false
    }
  })
})

export default {
  parseUserAccount
}
